export default "__VITE_ASSET__CnDyNOqP__"